var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfferSlider1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 14.438C24 16.648 22.21 18.438 20 18.438C17.79 18.438 16 16.648 16 14.438C16 12.228 17.79 10.438 20 10.438C22.21 10.438 24 12.228 24 14.438ZM20 36C16.356 36 10 22.02 10 14C10 8.486 14.486 4 20 4C25.514 4 30 8.486 30 14C30 22.02 23.644 36 20 36ZM20 0C12.268 0 6 6.268 6 14C6 21.732 12.268 40 20 40C27.732 40 34 21.732 34 14C34 6.268 27.732 0 20 0Z",
    fill: "#F68424"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferSlider1);
export default __webpack_public_path__ + "static/media/offer-slider-1.a6ff4aa606fa24d6b6198fa78fa30304.svg";
export { ForwardRef as ReactComponent };